module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Dashboards","filter":"Filter","tab-title-1":"Deals","tab-title-2":"Sales","tab-title-3":"Tasks","tab-title-4":"Financial"},"pt-BR":{"title":"Dashboards","filter":"Filtrar","tab-title-1":"Cards","tab-title-2":"Vendas","tab-title-3":"Tarefas","tab-title-4":"Financeiro"}}')
  delete Component.options._Ctor
}
